export default __webpack_public_path__ + "static/feature1-83a40217c9215a846fa5c9759724ed3b.png";